import React from 'react';
import Link from 'next/link';
import { Card } from '../ui/Card';
import { SafeImage } from '../ui/SafeImage';
import { getSongCoverArtwork } from '@/utils/songUtils';

export function SongCard({ song }) {
  if (!song) return null;

  const imageUrl = getSongCoverArtwork(song);
  const songTitle = song.title || song.song_name || 'Untitled Song';
  const movieTitle = song.movieTitle || song.movie_name || 'Movie';
  
  const musicDirector = song.musicDirectorName || song.musicDirector;
  const singersList = Array.isArray(song.singers) && song.singers.length > 0 
    ? song.singers.join(', ') 
    : (Array.isArray(song.singerNames) ? song.singerNames.join(', ') : '');

  const showMusicDirector = musicDirector && musicDirector !== 'Unknown' && musicDirector !== 'Artist' && musicDirector !== 'Not Specified';
  const isMusicDirSameAsSinger = showMusicDirector && singersList.toLowerCase().includes(musicDirector.toLowerCase());

  const line2 = isMusicDirSameAsSinger ? movieTitle : (showMusicDirector ? `${movieTitle} • ${musicDirector}` : movieTitle);
  const line3 = singersList;

  return (
    <Link href={`/song/${song.slug || song.id}`} prefetch={false} className="block group">
      <Card className="h-full border-none shadow-none bg-transparent transition-transform duration-300 group-hover:scale-[1.02]">
        <div className="relative aspect-[16/9] w-full overflow-hidden rounded-2xl bg-secondary/80 border border-border/60 shadow-xl">
          <SafeImage
            src={imageUrl}
            title={songTitle}
            subtitle={movieTitle}
            alt={`Song Cover Art for ${songTitle}`}
            fill
            className="object-cover group-hover:scale-105 transition-transform duration-500"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/40 to-transparent opacity-90 group-hover:opacity-100 transition-opacity pointer-events-none" />
          
          <div className="absolute bottom-0 left-0 p-3.5 sm:p-4 w-full text-white space-y-0.5 z-10">
            <h3 className="font-bold text-base md:text-lg leading-tight line-clamp-1 group-hover:text-primary transition-colors">
              {songTitle}
            </h3>
            <p className="text-xs text-zinc-300 font-medium truncate">
              {line2}
            </p>
            {line3 && (
              <p className="text-[11px] text-zinc-400 truncate pt-0.5 font-normal">
                {line3}
              </p>
            )}
          </div>
        </div>
      </Card>
    </Link>
  );
}
